/**
 * Find whether a variable is a string
 *
 * @param {mixed} variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is a string
 */
 const isString = ( variable ) => {
	return variable !== null && typeof variable === 'string';
};

export default isString;
